// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* ****Fonts**** */
/* ****Shadows (subtle elevation — flat SaaS)**** */
/* ****Border radius**** */
/* ****icon size**** */
/* **** Device width **** */
/* **** helper variable **** */
/* **** Motion **** */
.Input_form__control__XVNNl {
  position: relative;
  margin-bottom: 1.5rem;
  width: 100%;
}
.Input_form__control__XVNNl label {
  position: absolute;
  top: -0.65rem;
  left: 12px;
  background-color: var(--card-bgc);
  padding: 0 0.4rem;
  white-space: nowrap;
  font-size: 0.75rem;
  font-weight: 600;
  color: var(--text-muted);
  letter-spacing: 0.02em;
}
.Input_form__control__XVNNl input {
  width: 100%;
  min-width: 0;
  padding: 0.95rem 1rem;
  min-height: 48px;
  border: 1px solid var(--border-color);
  outline: none;
  background-color: var(--card-bgc);
  border-radius: 8px;
  color: var(--text-color);
  transition: border-color 150ms cubic-bezier(0.16, 1, 0.3, 1), box-shadow 150ms cubic-bezier(0.16, 1, 0.3, 1);
}
.Input_form__control__XVNNl input:hover:not(:disabled) {
  border-color: #cbd5e1;
}
.Input_form__control__XVNNl input:focus {
  border-color: var(--primaryColor);
  box-shadow: 0 0 0 3px rgba(3, 105, 161, 0.15);
  background-color: var(--card-bgc);
}
.Input_form__control__XVNNl input:disabled {
  background-color: var(--surface-muted);
}

html[dir=rtl] .Input_form__control__XVNNl label {
  left: auto;
  right: 12px;
}`, "",{"version":3,"sources":["webpack://./src/components/UI/input/Input.module.scss","webpack://./src/scss/abstracts/_variables.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACAhB,kBAAA;AAeA,mDAAA;AAIA,0BAAA;AAKA,sBAAA;AAIA,2BAAA;AAMA,8BAAA;AAOA,qBAAA;ADvCA;EACE,kBAAA;EACA,qBAAA;EACA,WAAA;AAOF;AALE;EACE,kBAAA;EACA,aAAA;EACA,UAAA;EACA,iCAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,wBAAA;EACA,sBAAA;AAOJ;AAJE;EACE,WAAA;EACA,YAAA;EACA,qBAAA;EACA,gBAAA;EACA,qCAAA;EACA,aAAA;EACA,iCAAA;EACA,kBCRgB;EDShB,wBAAA;EACA,4GAAA;AAMJ;AAJI;EACE,qBAAA;AAMN;AAHI;EACE,iCAAA;EACA,6CAAA;EACA,iCAAA;AAKN;AAFI;EACE,sCAAA;AAIN;;AAGI;EACE,UAAA;EACA,WAAA;AAAN","sourcesContent":["@use \"../../../scss/abstracts/\" as *;\r\n\r\n.form__control {\r\n  position: relative;\r\n  margin-bottom: 1.5rem;\r\n  width: 100%;\r\n\r\n  label {\r\n    position: absolute;\r\n    top: -0.65rem;\r\n    left: 12px;\r\n    background-color: var(--card-bgc);\r\n    padding: 0 0.4rem;\r\n    white-space: nowrap;\r\n    font-size: 0.75rem;\r\n    font-weight: 600;\r\n    color: var(--text-muted);\r\n    letter-spacing: 0.02em;\r\n  }\r\n\r\n  input {\r\n    width: 100%;\r\n    min-width: 0;\r\n    padding: 0.95rem 1rem;\r\n    min-height: 48px;\r\n    border: 1px solid var(--border-color);\r\n    outline: none;\r\n    background-color: var(--card-bgc);\r\n    border-radius: $smallBorderRadius;\r\n    color: var(--text-color);\r\n    transition: border-color $duration-fast $ease-out, box-shadow $duration-fast $ease-out;\r\n\r\n    &:hover:not(:disabled) {\r\n      border-color: #cbd5e1;\r\n    }\r\n\r\n    &:focus {\r\n      border-color: var(--primaryColor);\r\n      box-shadow: 0 0 0 3px rgba(3, 105, 161, 0.15);\r\n      background-color: var(--card-bgc);\r\n    }\r\n\r\n    &:disabled {\r\n      background-color: var(--surface-muted);\r\n    }\r\n  }\r\n}\r\n\r\nhtml[dir=\"rtl\"] {\r\n  .form__control {\r\n    label {\r\n      left: auto;\r\n      right: 12px;\r\n    }\r\n  }\r\n}\r\n","/* ****Fonts**** */\r\n\r\n//Body size\r\n$fontSizeBodySmall: 12px;\r\n$fontSizeBodyMedium: 14px;\r\n$fontSizeBodyLarge: 16px;\r\n//Headline size\r\n$fontSizeHeadlineSmall: 24px;\r\n$fontSizeHeadlineMedium: 36px;\r\n$fontSizeHeadlineLarge: 48px;\r\n//Display size\r\n$fontSizeDisplaySmall: 56px;\r\n//helper font size\r\n$fontSizeTableStatus: 11px;\r\n\r\n/* ****Shadows (subtle elevation — flat SaaS)**** */\r\n$mainBoxShadow: 0 1px 2px rgba(15, 23, 42, 0.06), 0 8px 24px rgba(15, 23, 42, 0.06);\r\n$secondBoxShadow: 0 12px 40px rgba(15, 23, 42, 0.18);\r\n\r\n/* ****Border radius**** */\r\n$smallBorderRadius: 8px;\r\n$mediumBorderRadius: 12px;\r\n$largeBorderRadius: 16px;\r\n\r\n/* ****icon size**** */\r\n$smallIconSize: 20px;\r\n$largeIconSize: 48px;\r\n\r\n/* **** Device width **** */\r\n$mobile-width: 576px;\r\n$tablet-width: 768px;\r\n$desktop-width: 992px;\r\n$largeDesktop-width: 1200px;\r\n\r\n/* **** helper variable **** */\r\n$sideBarOpenWidth: 248px;\r\n$sideBarCloseWidth: 72px;\r\n$spacing: 60px;\r\n$mobileSpacing: 16px;\r\n$sideBarLogoHeight: 171px;\r\n\r\n/* **** Motion **** */\r\n$ease-out: cubic-bezier(0.16, 1, 0.3, 1);\r\n$duration-fast: 150ms;\r\n$duration-base: 200ms;\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"form__control": `Input_form__control__XVNNl`
};
export default ___CSS_LOADER_EXPORT___;
